/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { memo } from 'react';

import { cssMap, jsx, keyframes } from '@compiled/react';

const fadeIn = keyframes({
	from: {
		opacity: 0,
	},
	to: {
		opacity: 1,
	},
});

const styles = cssMap({
	animatedContainer: {
		alignSelf: 'stretch',
		animation: `${fadeIn} 700ms cubic-bezier(0.3,0,0.8,0.15) forwards`,
		opacity: 0,
	},
	fillHeight: {
		height: '100%',
	},
	nonAnimatedContainer: {
		display: 'contents',
	},
});

export const AnimatedContainer: React.MemoExoticComponent<
	({
		children,
		isStreaming,
		fillHeight,
	}: {
		children: React.ReactNode;
		fillHeight?: boolean;
		isStreaming?: boolean;
	}) => JSX.Element
> = memo(
	({
		children,
		isStreaming = false,
		fillHeight = false,
	}: {
		children: React.ReactNode;
		fillHeight?: boolean;
		isStreaming?: boolean;
	}): JSX.Element => {
		if (isStreaming) {
			return (
				<div
					key="animated-container-div"
					css={[styles.animatedContainer, fillHeight && styles.fillHeight]}
				>
					{children}
				</div>
			);
		}

		return (
			<div key="animated-container-div" css={styles.nonAnimatedContainer}>
				{children}
			</div>
		);
	},
);

AnimatedContainer.displayName = 'AnimatedContainer';
